import React, { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

interface ChildProps {
  children: ReactNode;
}

const EntityLayout = ({ children }: ChildProps) => {
  const [exploreOffset, setExploreOffset] = useState(0);
  const { locale } = useRouter();

  useEffect(() => {
    const offset = document
      .getElementById('entity-data')
      ?.getBoundingClientRect().height;
    offset && setExploreOffset(offset);
  }, []);

  const router = useRouter();
  const isCompound = router.asPath.includes('compound');

  return (
    <EntityContainer
      className="container-fluid"
      exploreOffset={exploreOffset}
      locale={locale}
    >
      {children}
    </EntityContainer>
  );
};

const EntityContainer = styled.div<{
  exploreOffset: number;
  locale: string | undefined;
}>`
  display: flex;
  flex-direction: column;
  padding: 32px auto;
  .gallery-container {
    margin-bottom: 16px;
    height: 500px;
  }

  .launch-logo {
    position: relative;
    border-radius: 0px 0px 12px 12px;
    background: #002741;
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: ${props => (props.locale === 'en' ? 'row' : 'row-reverse')};
    gap: 8px;
    color: #fff;
    text-shadow:
      0px 0px 4px rgba(0, 0, 0, 0.04),
      0px 4px 8px rgba(0, 0, 0, 0.06);
    font-family: materialMedium;
    font-size: 30px;
    text-transform: uppercase;

    .launch-text {
      color: #e0c294;
      font-family: materialSemiBold;
      font-size: 40px;
      text-transform: uppercase;
      margin-bottom: 6px;
    }
  }

  .propertyDetails {
    width: 552px;
    @media (max-width: ${props => props.theme.breakPoints.tablet.max}) {
      width: 100%;
      padding: 0px 16px;
    }
  }

  .main-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    > div:not(#entity-data) {
      margin-top: 32px;
    }
    .entity-layout {
      justify-content: space-between;
      width: 100%;
      display: flex;
      flex-direction: row;
      gap: 64px;
    }

    .details-side {
      width: calc(100% - 320px);
      flex: 1;
      &.full-width {
        width: 100%;
      }
      > div:not(#breadcrumbs) {
        margin-top: 32px;
      }
    }

    .banners-side {
      width: 293px;
      height: auto;
      display: flex;
      flex-direction: column;
      margin-top: 8px;

      .form-container {
        width: 100%;
        position: -webkit-sticky;
        position: sticky;
        top: 160px;
        padding-top: 50px;

        .form {
          width: 100%;
        }
      }
    }
    .explore-container {
      margin-bottom: 32px;
    }
  }

  .explore-sticky-bar {
    top: ${props => `calc(${props.exploreOffset}px + 68px)`} !important;
  }
`;

export default EntityLayout;
